import { useRef } from "react";
import {
  getGroupBounds,
  resizeGroupObjects,
} from "../../../../utils/designerGroupUtils";

const MIN_WIDTH = 30;
const MIN_HEIGHT = 30;

const clampRect = (rect) => {
  const width = Math.max(MIN_WIDTH, rect.width);
  const height = Math.max(MIN_HEIGHT, rect.height);

  return {
    x: rect.x,
    y: rect.y,
    width,
    height,
  };
};

const applyResize = (direction, startRect, dx, dy) => {
  let { x, y, width, height } = startRect;

  if (direction.includes("e")) {
    width = startRect.width + dx;
  }

  if (direction.includes("s")) {
    height = startRect.height + dy;
  }

  if (direction.includes("w")) {
    width = startRect.width - dx;
    x = startRect.x + dx;
  }

  if (direction.includes("n")) {
    height = startRect.height - dy;
    y = startRect.y + dy;
  }

  if (width < MIN_WIDTH) {
    if (direction.includes("w")) {
      x = startRect.x + (startRect.width - MIN_WIDTH);
    }
    width = MIN_WIDTH;
  }

  if (height < MIN_HEIGHT) {
    if (direction.includes("n")) {
      y = startRect.y + (startRect.height - MIN_HEIGHT);
    }
    height = MIN_HEIGHT;
  }

  return { x, y, width, height };
};

const useResizeMove = ({
  object,
  objects = [],
  selectedGroupId = null,
  onSelect,
  updateObjectRect,
  updateObjectsBulk,
  disabled = false,
}) => {
  const resizingRef = useRef(false);

  const handleResizeStart = (e, direction) => {
    e.stopPropagation();
    e.preventDefault();

    onSelect?.(e);

    if (disabled) return;

    resizingRef.current = true;

    const startMouseX = e.clientX;
    const startMouseY = e.clientY;

    const isGroupResize =
      selectedGroupId && object.group && object.group === selectedGroupId;

    const groupObjects = isGroupResize
      ? (objects || []).filter((obj) => obj.group === selectedGroupId)
      : [];

    const startRect = isGroupResize
      ? getGroupBounds(groupObjects)
      : {
          x: object.x,
          y: object.y,
          width: object.width,
          height: object.height,
        };

    const handleMouseMove = (moveEvent) => {
      if (!resizingRef.current) return;

      const dx = moveEvent.clientX - startMouseX;
      const dy = moveEvent.clientY - startMouseY;

      const nextRect = clampRect(applyResize(direction, startRect, dx, dy));

      if (isGroupResize) {
        const nextObjects = resizeGroupObjects(
          objects,
          selectedGroupId,
          startRect,
          nextRect
        );
        updateObjectsBulk?.(nextObjects);
        return;
      }

      updateObjectRect?.(object.id, nextRect);
    };

    const handleMouseUp = () => {
      resizingRef.current = false;
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
  };

  return {
    handleResizeStart,
  };
};

export default useResizeMove;